module.exports = __webpack_public_path__ + "img/footer_logo_gps_chile.47152a0c.png";